import { render, staticRenderFns } from "./Configbar.vue?vue&type=template&id=20c4f351&"
import script from "./Configbar.vue?vue&type=script&lang=js&"
export * from "./Configbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports